import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import Features from "./Features";
import SlideShow from "./SlideShow";
import styles from "./slideShow.module.scss";
import { Verification } from "models/Verification";

type Props = {
  initialSlideIndex: number;
  onCloseModal: () => void;
  nameHidden: boolean;
  verifications: Verification[];
};

const SlideShowModal: React.FC<Props> = ({ initialSlideIndex, onCloseModal, nameHidden, verifications }) => {
  const [currentSlide, setCurrentSlide] = useState<number>(initialSlideIndex);
  const [currentVerification, setCurrentVerification] = useState(verifications[currentSlide]);

  useEffect(() => {
    setCurrentVerification(verifications[currentSlide]);
  }, [currentSlide]);

  const handleSlideshowModalClose = () => {
    onCloseModal();
  };

  // Update currentSlide state when child component SlideShow does so
  const handleSlideChange = (newSlide) => {
    setCurrentSlide(newSlide);
  };

  return (
    <>
      <Modal
        dialogClassName={styles.customModal}
        show={true}
        onHide={onCloseModal}
        animation={true}
      >
        <Modal.Header closeButton>
          <Modal.Title>Bilder & filmer ({verifications.length} st)</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex flex-column flex-md-row justify-content-center align-items-center">
            <SlideShow
              verifications={verifications}
              initialSlideIndex={initialSlideIndex}
              onSlideChange={handleSlideChange}
            />

            <Features
              currentSlide={currentSlide}
              currentVerification={currentVerification}
              setCurrentSlide={setCurrentSlide}
              handleSlideshowModalClose={handleSlideshowModalClose}
              nameHidden={nameHidden}
            />
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default SlideShowModal;
